import { useQuery } from '@tanstack/react-query';
import { UserProfileDto } from '@repo/shared/dtos/UserProfileDto';

export const USER_PROFILE_QUERY_KEY = 'userProfile';

export function useProfile() {
  return useQuery({
    queryKey: [USER_PROFILE_QUERY_KEY],
    queryFn: async (): Promise<UserProfileDto> => {
      const response = await fetch('/api/registrants/profile', {
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user profile');
      }

      return response.json();
    },
    retry: 1,
  });
}
